// @flow @jsx h

import { h, Component } from 'preact'
import { Sea } from './Sea'
import { TrashLayer } from './Trash'
import { Whale } from './Whale'
import { Light } from './Light'
import { Overlay } from './Overlay'
import { WhaleCaption } from './WhaleCaption'
import { WhaleImagesLoader } from './WhaleImagesLoader'
import { getTier } from '../../../lib/getTier'
import styles from './index.css'

import type { Answers } from '../../types'

type Props = {
  currentPosition: number,
  maxScore: number,
  isCorrect: boolean,
  isCaptionVisible: boolean,
  isResultView: boolean,
  answers: Answers
}

type State = {
  isWhaleReady: boolean
}

class Background extends Component<Props, State> {
  state = {
    isWhaleReady: false
  }

  componentDidMount(): void {
    setTimeout(() => {
      this.setState({
        isWhaleReady: true
      })
    }, 500)
  }

  render() {
    const {
      maxScore,
      currentPosition,
      isCaptionVisible,
      isResultView,
      isCorrect,
      answers
    } = this.props
    const { isWhaleReady } = this.state
    const positionPercentage = currentPosition / maxScore * 100
    const currentTier = getTier(currentPosition)

    return (
      <div class={styles.background} aria-hidden>
        <Sea currentTier={currentTier} />
        <TrashLayer index={1} positionPercentage={positionPercentage} />
        <TrashLayer index={2} positionPercentage={positionPercentage} />
        <WhaleImagesLoader />
        {isWhaleReady && (
          <Whale currentTier={currentTier}>
            <WhaleCaption
              isResultView={isResultView}
              isVisible={isCaptionVisible || isResultView}
              isCorrect={isCorrect}
              answers={answers}
              currentTier={currentTier}
            />
          </Whale>
        )}
        <TrashLayer index={3} positionPercentage={positionPercentage} />
        <Light />
        <Overlay currentTier={currentTier} />
      </div>
    )
  }
}

export { Background }



// WEBPACK FOOTER //
// ./src/v1/components/Background/index.js